import { useEffect, useRef } from "react";
/** Like `useEffect`, but without the "initial call" */
export const useOnChange = (call, dependencies) => {
    const effectFirstRun = useRef(true);
    useEffect(() => {
        if (effectFirstRun.current) {
            effectFirstRun.current = false;
            return;
        }
        call();
    }, dependencies);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlT25DaGFuZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlT25DaGFuZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFrQixTQUFTLEVBQUUsTUFBTSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBRTFELHVEQUF1RDtBQUN2RCxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQUcsQ0FDekIsSUFBZ0IsRUFDaEIsWUFBNEIsRUFDdEIsRUFBRTtJQUNSLE1BQU0sY0FBYyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUVwQyxTQUFTLENBQUMsR0FBRyxFQUFFO1FBQ2IsSUFBSSxjQUFjLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDM0IsY0FBYyxDQUFDLE9BQU8sR0FBRyxLQUFLLENBQUM7WUFDL0IsT0FBTztRQUNULENBQUM7UUFDRCxJQUFJLEVBQUUsQ0FBQztJQUNULENBQUMsRUFBRSxZQUFZLENBQUMsQ0FBQztBQUNuQixDQUFDLENBQUMifQ==